import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/AdminTheme.css";

function ProductCategories() {
  const [name, setName] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [editItem, setEditItem] = useState(null);

  // Load categories
  const fetchCategories = async () => {
    const { data, error } = await supabase
      .from("product_categories")
      .select("*")
      .order("created_at", { ascending: false });

    if (!error) setCategories(data);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Upload image to Supabase
 const uploadImage = async (file) => {
  if (!file) return null;

  const fileExt = file.name.split(".").pop();
  const fileName = `cat_${Date.now()}.${fileExt}`;
  const filePath = `categories/${fileName}`;

  const { data, error } = await supabase.storage
    .from("product-category")   // ← CHANGE THIS TO YOUR REAL BUCKET NAME
    .upload(filePath, file, {
      upsert: true,
    });

  if (error) {
    console.error("Upload error:", error);
    alert("Image upload failed: " + error.message);
    return null;
  }

  const { data: urlData } = supabase.storage
    .from("product-category")   // ← SAME BUCKET NAME
    .getPublicUrl(filePath);

  return urlData.publicUrl;
};

  // Add new category
  const addCategory = async () => {
    if (!name.trim()) return alert("Enter category name");

    let imageUrl = null;
    if (imageFile) imageUrl = await uploadImage(imageFile);

    await supabase.from("product_categories").insert([
      { name, image_url: imageUrl, status: true },
    ]);

    setName("");
    setImageFile(null);
    fetchCategories();
  };

  // Update category
  const saveEdit = async () => {
    let imageUrl = editItem.image_url;

    if (imageFile) imageUrl = await uploadImage(imageFile);

    await supabase
      .from("product_categories")
      .update({ name: editItem.name, image_url: imageUrl })
      .eq("id", editItem.id);

    setEditItem(null);
    setImageFile(null);
    fetchCategories();
  };

  // Delete category
  const deleteCategory = async (id) => {
    if (!window.confirm("Delete this category?")) return;

    await supabase.from("product_categories").delete().eq("id", id);
    fetchCategories();
  };

  return (
    <div className="page-container">
      <h2>🗂 Product Categories</h2>

      {/* ADD CATEGORY */}
      <div className="card">
        <label>Category Name</label>
        <input
          type="text"
          placeholder="e.g. Bangles"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label>Upload Image</label>
        <input type="file" onChange={(e) => setImageFile(e.target.files[0])} />

        <button className="main-btn" onClick={addCategory}>
          Add Category
        </button>
      </div>

      {/* CATEGORY LIST TABLE */}
      <h3>Category List</h3>

      <table className="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>Status</th>
            <th style={{ width: "180px" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {categories.map((cat) => (
            <tr key={cat.id}>
              <td>
                {cat.image_url ? (
                  <img src={cat.image_url} width="55" height="55" />
                ) : (
                  "—"
                )}
              </td>

              <td>{cat.name}</td>

              <td>{cat.status ? "Active" : "Inactive"}</td>

              <td>
                <button className="edit-btn" onClick={() => setEditItem(cat)}>
                  Edit
                </button>

                <button
                  className="delete-btn"
                  onClick={() => deleteCategory(cat.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* EDIT POPUP */}
      {editItem && (
        <div className="popup-overlay">
          <div className="popup-card">
            <h3>Edit Category</h3>

            <label>Name</label>
            <input
              type="text"
              value={editItem.name}
              onChange={(e) =>
                setEditItem({ ...editItem, name: e.target.value })
              }
            />

            <label>Change Image</label>
            <input type="file" onChange={(e) => setImageFile(e.target.files[0])} />

            <div className="popup-actions">
              <button className="main-btn" onClick={saveEdit}>
                Save
              </button>
              <button className="delete-btn" onClick={() => setEditItem(null)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductCategories;
